import React from 'react';
import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope } from '../../../util/useSelectorFunctions';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import { useDeleteResourceDialogFunction } from '../../../reusable-components/dialogs/UseDeleteResourceDialogFunction';
import {
    defaultVCycleElementDecoratorResource,
    useVCycleElementDecoratorActions,
    VCycleElementDecoratorMutationResourceSchema,
} from '../../../../resource/resources/artifacts/use_case/representation/vcycleElementDecoratorResource';
import { VCycleElementDecoratorEditDialog } from '../vcycle-element-decorator/VCycleElementDecoratorEditDialog';
import { VCycleElementDecoratorCreationDialog } from '../vcycle-element-decorator/VCycleElementDecoratorCreationDialog';
import { NonCollapsibleQueryStateComponent } from '../../../reusable-components/base/NonCollapsibleQueryStateComponent';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { VCycleElementDecoratorContent } from '../vcycle-element-decorator/VCycleElementDecoratorContent';

export const VCycleElementDecoratorDisplay = ({
    parentId,
}: {
    parentId: string;
}) => {
    const deleteResourceDialogFunction = useDeleteResourceDialogFunction();
    const nestedDialog = useNestedDialogFunction();

    const noScope = useSelector(selectNoScopeValidationScope);

    const vCycleElementDecoratorActions = useVCycleElementDecoratorActions()
    const vCycleElementDecoratorQuery = vCycleElementDecoratorActions.useGetSingleResource(parentId);
    const validationQuery = vCycleElementDecoratorActions.useValidateResource(
        vCycleElementDecoratorQuery.data?.id,
        noScope,
    );
    const deleteVCycleElementDecorator = vCycleElementDecoratorActions.useDeleteResource();

    const { form, formNames } = useMyForm({
        schema: VCycleElementDecoratorMutationResourceSchema,
        defaultValues: defaultVCycleElementDecoratorResource,
        reactiveValues: vCycleElementDecoratorQuery.data,
    });

    const openEditDialog = () => {
        const resource = vCycleElementDecoratorQuery.data;
        if (resource) {
            nestedDialog.showNestedDialog(
                <VCycleElementDecoratorEditDialog
                    onClose={nestedDialog.closeNestedDialog}
                    objectId={resource.objectId}
                    versionedInId={resource.versionedIn}
                />,
            );
        }
    };

    const openAddDialog = () => {
        nestedDialog.showNestedDialog(
            <VCycleElementDecoratorCreationDialog
                onClose={nestedDialog.closeNestedDialog}
                parentId={parentId}
            />,
        );
    };

    return (
        <NonCollapsibleQueryStateComponent
            query={vCycleElementDecoratorQuery}
            resourceType={ResourceType.V_CYCLE_ELEMENT_DECORATOR}
            label={'V-Cycle Element Decorator'}
            readOnly={true}
            validationResource={validationQuery.data}
            handleAddClick={openAddDialog}
            handleEditClick={openEditDialog}
            handleDeleteClick={() => {
                const resource = vCycleElementDecoratorQuery.data;
                if (resource) {
                    deleteResourceDialogFunction.deleteResource(
                        resource.id,
                        undefined,
                        ResourceType.V_CYCLE_ELEMENT_DECORATOR,
                        deleteVCycleElementDecorator,
                    );
                }
            }}
        >
            <VCycleElementDecoratorContent form={form} formNames={formNames} readOnly={true} id={vCycleElementDecoratorQuery.data?.id} />
        </NonCollapsibleQueryStateComponent>
    );
};